import React from 'react';
import { DynamicForm } from 'modules/account/components/DynamicForm/DynamicForm';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import TermsCheckboxes from '../../../components/TermsCheckboxes/TermsCheckboxes';
import { USER_DATA_KEY } from '../../../constantes/LocalStorageEnum';

const Personal: React.FC = () => (
  <>
    <DynamicForm
      pageName="personal"
      initialValues={ApiLocalStorage.get(USER_DATA_KEY)}
    >
      <TermsCheckboxes/>
    </DynamicForm>
  </>
)

export default Personal;
